
//import "bootstrap/dist/js/bootstrap.bundle.min.js";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import App  from "./App.js";
import reducers from "./reducers";
import registerServiceWorker from "./registerServiceWorker.js";
import axios from "axios";
import "./css/bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "jquery";

window.axios = axios;

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
  <Provider store={store}>
    <App  />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js